export const STRIPE_PUBLISHABLE_KEY =
  "pk_live_51TQBc62QvchQsGbyYzTa0VPJYfAYXlqndGFMZWlCmAc4wBNUd6IVEz40VN8L45NdqPwBXpUwRsObnBhcNd5FeNhZ00Rkz3zkEU";
